module.exports = __webpack_public_path__ + "static/img/obj4.efb2f2bc.png";